export const resolveBookCoverName = (name: string, surname?: string) => {
  const isNameLongerThan10 = name?.length > 10;
  const isSurameLongerThan10 = surname && surname.length > 10;
  const isSurname = Boolean(surname && surname.trim());
  const formattedName = surname ? `${name}<br/>${surname}` : name;
  return {
    isNameLongerThan10,
    isSurameLongerThan10,
    isSurname,
    formattedName,
  };
};
